export default __webpack_public_path__ + "static/media/search.97985126.svg";